import { render } from "./PlatformCordinator.vue?vue&type=template&id=141b5012&scoped=true"
import script from "./PlatformCordinator.vue?vue&type=script&lang=js"
export * from "./PlatformCordinator.vue?vue&type=script&lang=js"

import "./PlatformCordinator.vue?vue&type=style&index=0&id=141b5012&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-141b5012"]])

export default __exports__